var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_3378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1592 15.3874L43.2067 15.6978C42.7476 14.0685 41.5078 12.8114 39.9324 12.3538L39.8991 12.3459C36.9367 11.5415 25.0158 11.5415 25.0158 11.5415C25.0158 11.5415 13.125 11.5257 10.1325 12.3459C8.52698 12.8114 7.28564 14.0685 6.83439 15.6645L6.82648 15.6978C5.71973 21.4785 5.71181 28.4246 6.87556 34.6139L6.82648 34.3004C7.28564 35.9296 8.52539 37.1868 10.1008 37.6444L10.1341 37.6523C13.0933 38.4582 25.0174 38.4582 25.0174 38.4582C25.0174 38.4582 36.9066 38.4582 39.9007 37.6523C41.5078 37.1868 42.7491 35.9296 43.2004 34.3336L43.2083 34.3004C43.7118 31.6119 44 28.518 44 25.3577C44 25.2421 44 25.1249 43.9984 25.0078C44 24.9001 44 24.7719 44 24.6436C44 21.4817 43.7118 18.3879 43.1592 15.3874ZM21.2126 30.7806V19.2334L31.1338 25.0157L21.2126 30.7806Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_3378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4471535bf5d994b1db6d9bf0e1ba9a9c.svg";
export { ForwardRef as ReactComponent };